module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAPVJREFUOE+t0ztKREEQheGvDIx0ASYuQMFUYxHBPZj5ANFAXIgaOAg+MvcgiBhrKugCTFyAExnYUtIXriMD452prLr7/FWnuzoMRCllEdtYx3zdfsMdriLipS2JJimlTOMYe5gaBNf8C+c4iojPXPsBVPEtVjPNSrhGUy272qqdpeYBGwlpAGfYxzs2IyIP/IlSSha4wRx6EXEQ1fNz7WZtmLhlNSH3tdOlBJzgEJcRsTvE+6/lUsoFdnCagPS5gJWIeBoRsIxHvCbgAzOYjYj+iIA8n7r+RABjWxj7EnNIuj9jncTugzSRUW5Bun2m9tv/9zt/A07ulP0eAO68AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top_default.png
// module id = coQF
// module chunks = 1